import {
  CloseOutlined,
  DeleteOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unitCaseEnum } from '../../utils/settings';
import { Button, notification } from 'antd';
import NO_IMAGE from '../Utils/Assets/noImage.jpg';
import { Typography } from '@mui/material';

function FmcgProdCard({
  prod,
  index,
  itemInCart = {},
  noShadow = false,
  checkout = false,
  isHomogeneous = false,
}) {
  const dispatch = useDispatch();
  const [enteredValue, setEnteredValue] = useState('');

  const { product_info, allocable_quantity, price_info } = prod;

  const { unitCaseWise, isSellToBuyer } = useSelector((state) => {
    return {
      // FMCG
      unitCaseWise: state.fmcgReducer.unitCaseWise,
      isSellToBuyer: state.fmcgReducer.isSellToBuyer,
    };
  });

  const updateProdQty = ({ type, data, inputValue = null }) => {
    setEnteredValue('');

    const unitQty = data.allocable_quantity.quantity_in_bags;
    const caseQty = data.allocable_quantity.quantity_in_metric_ton;

    if (unitCaseWise === unitCaseEnum['CASE'] && caseQty < 1)
      return notification.error({ message: 'Not enought Cases to add' });

    if (
      inputValue &&
      unitCaseWise === unitCaseEnum['UNIT'] &&
      unitQty < Number(inputValue)
    )
      return notification.error({ message: 'Not enought Units to add' });

    dispatch({
      type: 'UPDATE_PROD_QTY',
      data: {
        type: type,
        data: data,
        inputValue: inputValue,
      },
    });
  };

  function removeProduct() {
    updateProdQty({
      type: 'DELETE',
      data: prod,
    });
  }
  // FMCG
  return (
    <div
      className={`prodCard ${isSellToBuyer && 'prodCardHoriz'} ${
        noShadow && 'noShadow'
      }`}
      key={index}
    >
      {checkout && (
        <Button
          onClick={removeProduct}
          className='deleteButton'
          shape='circle'
          danger
          type='primary'
        >
          <DeleteOutlined />
        </Button>
      )}
      <img
        className={`prodImg ${isSellToBuyer && 'prodImgHoriz'}`}
        src={product_info?.product_logo.split(',')[0] || NO_IMAGE}
        alt='product'
      />
      <div className='prodDetails'>
        <p className='prodTitle'>{product_info?.product_name}</p>
        <p>{prod.meta_data?.Type}</p>

        {price_info?.mrp && price_info?.rlp && (
          <div className='mrpCtr'>
            <p className='sellingPrice'>
              ₹{' '}
              {unitCaseWise === unitCaseEnum['UNIT']
                ? price_info.rlp.toFixed(2)
                : (price_info.rlp * allocable_quantity?.multiplier).toFixed(2)}
            </p>
            <p className='mrp'>
              ₹{' '}
              {unitCaseWise === unitCaseEnum['UNIT']
                ? price_info.mrp.toFixed(2)
                : (price_info.mrp * allocable_quantity?.multiplier).toFixed(2)}
            </p>
          </div>
        )}

        <p>
          {unitCaseWise === unitCaseEnum['UNIT']
            ? `${allocable_quantity?.quantity_in_bags} ${allocable_quantity?.base_unit}`
            : `${allocable_quantity?.quantity_in_metric_ton} ${allocable_quantity?.unit} (${allocable_quantity?.multiplier} ${allocable_quantity?.base_unit} / ${allocable_quantity?.unit})`}
        </p>

        {isHomogeneous ? null : (
          <>
            {isSellToBuyer && (
              <div className='addQtyCtr'>
                <MinusCircleOutlined
                  onClick={() => updateProdQty({ type: 'REMOVE', data: prod })}
                  className='addRemoveIcon'
                />
                <input
                  className='qtyInput'
                  value={
                    enteredValue
                      ? enteredValue
                      : itemInCart?.sellToBuyerQty?.qty || 0
                  }
                  onChange={(e) => {
                    const userInput = e.target.value;
                    const regex = /^[0-9]*$/; // This regex ensures only numbers are allowed

                    if (regex.test(userInput)) {
                      setEnteredValue(userInput);
                    }
                  }}
                  onBlur={() =>
                    updateProdQty({
                      type: 'ADD',
                      data: prod,
                      inputValue: Number(enteredValue),
                    })
                  }
                />
                <PlusCircleOutlined
                  onClick={() => updateProdQty({ type: 'ADD', data: prod })}
                  className='addRemoveIcon'
                />
                <Typography>
                  {unitCaseWise === unitCaseEnum['UNIT']
                    ? `${allocable_quantity?.base_unit}`
                    : ` ${allocable_quantity?.unit}`}
                </Typography>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default FmcgProdCard;
